import styled from "styled-components";

export const CorperateDetailContainerStyled = styled.div`
  border-radius: 1rem;
  padding: 1.25rem;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  .block_section {
    margin-bottom: 2rem;
    .title {
      margin-bottom: 0.75rem;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
    }
    .cus_info_row {
      display: flex;
      .ci_left_col {
        flex: 1;
      }
      .ci_right_col {
        flex: 1;
      }
    }
    .value_item_wrap {
    }
  }
  .product_set_section {
    padding-top: 1.5rem;
    border-top: 1px solid ${({ theme }) => theme.COLORS.GRAY_7};
    .section_header {
      margin-bottom: 1rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        margin-bottom: 0;
      }
      .w150 {
        width: 150px;
      }
    }
    .row_click {
      cursor: pointer;
    }
  }
  .box_back {
    display: flex;
    justify-content: flex-end;
    column-gap: 1rem;
    .w150 {
      width: 150px;
    }
  }
`;
